module.exports = __webpack_public_path__ + "img/game_sign_title.44e9ae9e.png";